import { Transition }               from '@uirouter/core';

import { ApiService }                          from '../api/api.service';
import { DateParserService }                   from '../core/services/date-parser.service';
import { TableService }                        from '../table/table.service';
import { TransactionCenterInspectionsService } from './inspections/transaction-center.inspections.service';

import { TransactionCenterComponent }               from './transaction-center.component';
import { TransactionCenterBookingsComponent }       from './transaction-center.bookings.component';
import { TransactionCenterInspectionsComponent }    from './inspections/transaction-center.inspections.component';
import { TransactionCenterJobsComponent }           from './jobs/transaction-center.jobs.component';
import { TransactionCenterOrdersComponent }         from './transaction-center.orders.component';
import { TransactionCenterVendorInvoicesComponent } from './transaction-center.vendor-invoices.component';

export const TransactionCenterStates: Array<any> = [
  {
    component  : TransactionCenterComponent,
    name       : 'app.transaction-center',
    url        : '/transaction-center',
    redirectTo : 'app.transaction-center.jobs'
  },
  {
    component: TransactionCenterBookingsComponent,
    data     : { tableCacheKey: 'transactionCenterBookings' },
    name     : 'app.transaction-center.bookings',
    resolve  : [
      { token: 'bookings', deps: [Transition, DateParserService, TableService, ApiService],
        resolveFn: (transition: Transition, dateParserService: DateParserService, tableService: TableService, apiService: ApiService) => {
          const cache = tableService.getCacheForTable(transition.to().data.tableCacheKey);
          return apiService.get('/transaction_center/bookings', [
            cache.filtering.startDate || dateParserService.weekRangeStart(null),
            cache.filtering.endDate   || dateParserService.weekRangeEnd(null),
            cache.filtering.value     || '*',
            cache.sorting.field       || 'event_date',
            cache.sorting.direction   || 'desc',
            cache.paging.pageSize     || 10,
            0
          ]);
        }
      }
    ],
    url: '/bookings'
  },
  {
    component: TransactionCenterInspectionsComponent,
    data     : { tableCacheKey: 'transactionCenterInspections' },
    name     : 'app.transaction-center.inspections',
    resolve  : [
      { token: 'inspections', deps: [Transition, TableService, TransactionCenterInspectionsService],
        resolveFn: (transition: Transition, tableService: TableService, inspectionsService: TransactionCenterInspectionsService) => {
          const cache = tableService.getCacheForTable(transition.to().data.tableCacheKey);
          return inspectionsService.getInspections({
            status: cache.filtering.status || 'D',
            value : cache.filtering.value  || '*' }, {
            field    : cache.sorting.field     || 'inspection_date',
            direction: cache.sorting.direction || 'desc',
            pageSize : cache.paging.pageSize   || 10 });
        }
      },
      { token: 'statuses', deps: [ApiService], resolveFn: (apiService: ApiService) => apiService.get('/system/inspection_status_type_filters') }
    ],
    url: '/inspections'
  },
  {
    component: TransactionCenterJobsComponent,
    data     : { tableCacheKey: 'transactionCenterJobs' },
    name     : 'app.transaction-center.jobs',
    resolve  : [
      { token: 'constraints',      deps: [ApiService], resolveFn: (apiService: ApiService) => apiService.get('/system/job_filter_constraint_types') },
      { token: 'jobStatusOptions', deps: [ApiService], resolveFn: (apiService: ApiService) => apiService.get('/system/filter_job_status_types') },
      { token: 'jobStatuses',      deps: [ApiService], resolveFn: (apiService: ApiService) => apiService.get('/system/job_status_types') },
      { token: 'jobs', deps: [Transition, TableService, ApiService],
        resolveFn: (transition: Transition, tableService: TableService, apiService: ApiService) => {
          const cache = tableService.getCacheForTable(transition.to().data.tableCacheKey);
          return apiService.stream('/job_center', [
            cache.filtering.value       || '*',
            0,
            cache.paging.pageSize       || 10,
            cache.filtering.postDate    || '*',
            cache.filtering.constrainBy || '*',
            cache.filtering.jobStatus   || '*',
            cache.sorting.field         || 'invoice.post_date',
            cache.sorting.direction     || 'desc'
          ]);
        }
      }
    ],
    url: '/jobs'
  },
  {
    component: TransactionCenterOrdersComponent,
    data     : { tableCacheKey: 'transactionCenterOrders' },
    name     : 'app.transaction-center.orders',
    resolve  : [
      { token: 'orders', deps: [Transition, TableService, ApiService],
        resolveFn: (transition: Transition, tableService: TableService, apiService: ApiService) => {
          const cache = tableService.getCacheForTable(transition.to().data.tableCacheKey);
          return apiService.get('/transaction_center/purchase_orders', [
            cache.filtering.startDate       || '*',
            cache.filtering.endDate         || '*',
            cache.filtering.outstandingOnly || false,
            cache.filtering.status          || '*',
            cache.filtering.value           || '*',
            cache.sorting.field             || 'order_date',
            cache.sorting.direction         || 'desc',
            cache.paging.pageSize           || 10,
            0
          ]);
        }
      },
      { token: 'statuses', deps: [ApiService], resolveFn: (apiService: ApiService) => apiService.get('/system/purchase_order_status_types') }
    ],
    url: '/orders'
  },
  {
    component: TransactionCenterVendorInvoicesComponent,
    data     : { tableCacheKey: 'transactionCenterVendorInvoices' },
    name     : 'app.transaction-center.vendor-invoices',
    resolve  : [
      { token: 'invoices', deps: [Transition, TableService, ApiService],
        resolveFn: (transition: Transition, tableService: TableService, apiService: ApiService) => {
          const cache = tableService.getCacheForTable(transition.to().data.tableCacheKey);
          return apiService.get('/transaction_center/supplier_invoices', [
            cache.filtering.startDate || '*',
            cache.filtering.endDate   || '*',
            cache.filtering.status    || 'I',
            cache.filtering.value     || '*',
            cache.sorting.field       || 'post_date',
            cache.sorting.direction   || 'desc',
            cache.paging.pageSize     || 10,
            0
          ]);
        }
      },
      { token: 'statuses', deps: [ApiService], resolveFn: (apiService: ApiService) => apiService.get('/system/vendor_invoice_type_filters') }
    ],
    url: '/vendor-invoices'
  }
];
